import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { baseApiClient } from '@/api/clients'
import { BaseApiCitation } from '@/types/api'

export const useCitationsStore = defineStore('citationsStore', () => {
  const promptMessageAndCitations = reactive<{ [key: string]: number[] | null }>({})
  const idAndCitation = reactive<{ [key: number]: BaseApiCitation }>({})

  const getCitationsForPrompt = (promptMessage: string, defaultCitations: number[] | null) => {
    if (typeof promptMessageAndCitations[promptMessage] === 'undefined') {
      promptMessageAndCitations[promptMessage] = defaultCitations
      return defaultCitations
    }

    return promptMessageAndCitations[promptMessage]
  }

  const getCitations = async (citationIds: number[] | null): Promise<BaseApiCitation[]> => {
    const res: BaseApiCitation[] = []

    if (citationIds === null) {
      return res
    }

    for (const citationId of citationIds) {
      let citation: BaseApiCitation | undefined = undefined

      if (typeof idAndCitation[citationId] === 'undefined') {
        const citationResp = await baseApiClient.get<{ data: BaseApiCitation }>(`citations/${citationId}`)
        citation = citationResp.data.data
        idAndCitation[citationId] = citation
      } else {
        citation = idAndCitation[citationId]
      }

      if (citation.title.length > 0) {
        res.push(citation)
      }
    }

    return res
  }

  return { getCitationsForPrompt, getCitations }
})
